import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import {
  Alert,
  Avatar,
  Button,
  Card,
  Descriptions,
  Dropdown,
  Flex,
  Image,
  Input,
  List,
  Menu,
  message,
  Modal,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import image404 from "src/assets/404.png";
import { ImageList } from "src/features/Lists"; 
import { axiosBaseURL} from "src/shared/api/axiosInstance";  // axiosInstance убрали он здесь не нужен, передача не через ирл
import PropTypes from 'prop-types';
import axios from "axios";

const { Title, Text } = Typography;

const OrderPicker = () => {
  const [orderData, setOrderData] = useState(null);
const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash");
  const [error, setError] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [isAuthModalVisible, setIsAuthModalVisible] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("authToken") || "");
  const [authError, setAuthError] = useState(null);
  const [userData, setUserData] = useState(null);
  const [userLoading, setUserLoading] = useState(false);
  
  const axiosOrderPickerInstance = React.useMemo(() => {
  const instance = axios.create({
    baseURL: axiosBaseURL,
    headers: { "Content-Type": "application/json" },
  });

  instance.interceptors.request.use((config) => {
    //только localStorage, без переменной token
    const currentToken = localStorage.getItem("authToken");
    if (currentToken) {
      config.params = {
        ...config.params,
        token: currentToken
      };
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 403) {
        message.error("Доступ запрещен. Проверьте права пользователя.");
        localStorage.removeItem("authToken");
        setUserData(null);
        setToken("");
      }
      return Promise.reject(error);
    }
  );

  return instance;
}, []); 

  const fetchOrderData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosOrderPickerInstance.get(
        `/docs_sales/verify/${hash}?order_id=${id}&role=picker`
      );
      setOrderData(response.data);
      setError(null);
    } catch (err) {
      setError("Не удалось загрузить данные заказа. Проверьте корректность ссылки.");
    } finally {
      setLoading(false);
    }
  }, [id, hash, axiosOrderPickerInstance]);

  const fetchUserData = useCallback(async () => {
    try {
      setUserLoading(true);
      const response = await axiosOrderPickerInstance.get(`/users/`);
      setUserData(response.data);
      return response.data;
    } catch (err) {
      return null;
    } finally {
      setUserLoading(false);
    }
  }, [axiosOrderPickerInstance]);

useEffect(() => {
  if (id && hash) {
    fetchOrderData();
  }

  const savedToken = localStorage.getItem("authToken");
  console.log(savedToken);
  if (savedToken) {
    fetchUserData();
  }
}, [id, hash, fetchOrderData, fetchUserData]);

  useEffect(() => {
    console.log(localStorage.getItem("authToken"));
  }, []);

  const handleAuthSubmit = async () => {
  if (!token.trim()) {
    setAuthError("Токен не может быть пустым");
    return;
  }

  try {
    localStorage.setItem("authToken", token);
    setAuthError(null);
    
    // После сохранения токена в localStorage, axios interceptor будет его использовать
    const user = await fetchUserData();
    
    if (user) {
      setIsAuthModalVisible(false);
      message.success("Токен сохранен успешно");
    } else {
      localStorage.removeItem("authToken");
      setAuthError("Неверный токен. Проверьте корректность токена.");
    }
  } catch (err) {
    console.error("Ошибка при авторизации:", err);
    localStorage.removeItem("authToken");
    setAuthError("Ошибка авторизации. Проверьте корректность токена.");
  }
};

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    message.success("Вы успешно вышли из системы");
    window.location.reload();
  };

  const handleAssignPicker = async () => {
    try {
      const savedToken = localStorage.getItem("authToken");
      if (!savedToken) {
        message.error("Необходим токен для действия");
        setIsAuthModalVisible(true);
        return;
      }

      setActionLoading(true);

      let user = userData;
      if (!user) {
        user = await fetchUserData();
        if (!user) {
          message.error("Не удалось получить данные пользователя");
          setActionLoading(false);
          return;
        }
      }

      await axiosOrderPickerInstance.patch(
        `/docs_sales/${id}/assign/picker`,
        {
          user_id: user.id,
        }
      );

      if (orderData.status === "received") {
        await axiosOrderPickerInstance.patch(
          `/docs_sales/${id}/status`,
          {
            status: "processed",
            comment: "Заказ назначен сборщику",
          }
        );
      }

      message.success("Вы успешно назначены сборщиком этого заказа");
      fetchOrderData();
    } catch (err) {
      console.error("Ошибка при назначении сборщика:", err);
      if (err.response && err.response.status === 401) {
        message.error("Пользователь не авторизован или отсутствует в учетной записи");
      } else {
        message.error("Не удалось назначить сборщика");
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleStartCollection = async () => {
    try {
      const savedToken = localStorage.getItem("authToken");
      if (!savedToken) {
        message.error("Необходим токен для действия");
        setIsAuthModalVisible(true);
        return;
      }
  
      setActionLoading(true);
      
      await axiosOrderPickerInstance.patch(
        `/docs_sales/${id}/status`,
        {
          status: "collecting",
          comment: "Сборка начата",
        }
      );
  
      message.success("Сборка заказа начата");
      fetchOrderData();
    } catch (err) {
      message.error("Не удалось начать сборку");
    } finally {
      setActionLoading(false);
    }
  };

  const handleFinishCollection = async () => {
    try {
      const savedToken = localStorage.getItem("authToken");
      if (!savedToken) {
        message.error("Необходим токен для действия");
        setIsAuthModalVisible(true);
        return;
      }

      setActionLoading(true);
      
      await axiosOrderPickerInstance.patch(
        `/docs_sales/${id}/status`,
        {
          status: "collected",
          comment: "Сборка завершена",
        }
      );

      message.success("Сборка заказа завершена");
      message.warning("Не забудьте прикрепить фото");
      fetchOrderData();
    } catch (err) {
      console.error("Ошибка при завершении сборки:", err);
      message.error("Не удалось завершить сборку");
    } finally {
      setActionLoading(false);
    }
  };

  const handleCancelCollection = async () => {
    const savedToken = localStorage.getItem("authToken");
    if (!savedToken) {
      message.error("Необходим токен для действия");
      setIsAuthModalVisible(true);
      return;
    }
  
    setActionLoading(true);
  
    try {
      await axiosOrderPickerInstance.patch(
        `/docs_sales/${id}/status`,
        {
          status: "closed",
          comment: "Сборка отменена: товар отсутствует или нет возможности",
        }
      );
  
      message.success("Сборка отменена");
      await fetchOrderData();
      
    } catch (err) {
      message.error("Не удалось отменить сборку");
    } finally {
      setActionLoading(false);
    }
  };

  const getStatusTag = (status) => {
    const statusMap = {
      received: { color: "blue", text: "Получен" },
      processed: { color: "purple", text: "Обработан" },
      collecting: { color: "orange", text: "Собирается" },
      collected: { color: "cyan", text: "Собран" },
      picked: { color: "geekblue", text: "Забран" },
      delivered: { color: "green", text: "Доставлен" },
      cancelled: { color: "red", text: "Отменён" },
    };

    const defaultStatus = { color: "default", text: status };
    const currentStatus = statusMap[status] || defaultStatus;

    return <Tag color={currentStatus.color}>{currentStatus.text}</Tag>;
  };

  const avatarMenu = (
    <Menu style={{ width: "fit-content" }}>
      <Menu.Item disabled>
        <Space
          style={{ width: "100%", justifyContent: "center", padding: "5px" }}
        >
          <Avatar
            size={60}
            src={`https://${process.env.REACT_APP_APP_URL}/${userData?.photo}`}
          />
        </Space>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="user-info" disabled>
        <Space style={{ columnGap: 5 }}>
          <Text style={{ fontSize: 14 }}>Здравствуйте,</Text>
          <Text strong style={{ fontSize: 14 }}>
            {userData?.first_name || userData?.username || "Пользователь"}
          </Text>
        </Space>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item style={{ justifyContent: "center" }}>
        <Button
          style={{ width: "100%" }}
          icon={<LogoutOutlined />}
          onClick={() => handleLogout()}
        >
          Выйти
        </Button>
      </Menu.Item>
    </Menu>
  );

  const renderActionButtons = () => {
    if (!orderData) {
      return null;
    }
    if (orderData.status === "cancelled") {
      return <CancelledOrderAlert comment={orderData.comment} />;
    }
    if (!orderData.assigned_picker) {
      if (orderData.status === "received" || orderData.status === "processed") {
        return (
          <Button
            type="primary"
            onClick={handleAssignPicker}
            loading={actionLoading || userLoading}
          >
            Я соберу
          </Button>
        );
      } else {
        return (
          <Alert
            message="Недоступно"
            description="Заказ находится в статусе, который не позволяет назначить сборщика"
            type="warning"
            showIcon
          />
        );
      }
    }
  
    if (orderData.status === "received" || orderData.status === "processed") {
      return (
        <>
          <Button
            type="primary"
            onClick={handleStartCollection}
            loading={actionLoading}
            style={{ marginRight: "10px" }}
          >
            Я начал(а) сборку
          </Button>
          <Button
            danger
            onClick={handleCancelCollection}
            loading={actionLoading}
          >
            Отказ (Нет в наличии/Нет возможности)
          </Button>
        </>
      );
    } else if (orderData.status === "collecting") {
      return (
        <>
          <Button
            type="primary"
            onClick={handleFinishCollection}
            loading={actionLoading}
            style={{ marginRight: "10px" }}
          >
            Я завершил(а) сборку
          </Button>
          <Button
            danger
            onClick={handleCancelCollection}
            loading={actionLoading}
          >
            Отказ (Нет в наличии/Нет возможности)
          </Button>
        </>
      );
    } else if (orderData.status === "collected") {
      return (
        <Alert
          message="Сборка завершена"
          description="Заказ успешно собран и ожидает курьера"
          type="success"
          showIcon
        />
      );
    } else if (
      orderData.status === "picked" ||
      orderData.status === "delivered"
    ) {
      return (
        <Alert
          message="Заказ передан курьеру"
          description="Заказ уже передан курьеру для доставки"
          type="info"
          showIcon
        />
      );
    }
  
    return null;
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px" }}>
        <Alert message="Ошибка" description={error} type="error" showIcon />
      </div>
    );
  }
  const CancelledOrderAlert = ({ comment }) => {
    return (
      <Card
        style={{
          marginTop: "20px",
          border: "1px solid #f5222d",
          backgroundColor: "#fff1f0",
          borderRadius: "8px",
        }}
      >
        <Flex
          vertical
          gap={10}
          style={{ justifyContent: "center", alignItems: "center" }}
        >
          <Alert
            message="Сборка отменена"
            description={comment || "Заказ был отменён"}
            type="error"
            showIcon
            style={{ width: "100%" }}
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/1828/1828665.png"
            alt="Отмена"
            style={{ width: "60px", marginTop: "10px", opacity: 0.7 }}
          />
        </Flex>
      </Card>
    );
  };
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      {orderData ? (
        <Card
          title={<Title level={3}>Заказ #{orderData?.number} (Сборка)</Title>}
        >
          <Descriptions bordered>
            <Descriptions.Item label="Статус" span={3}>
              {orderData?.status && getStatusTag(orderData.status)}
            </Descriptions.Item>
            <Descriptions.Item label="ID" span={3}>
              {orderData?.id}
            </Descriptions.Item>
            <Descriptions.Item label="Склад" span={3}>
              {orderData?.warehouse_name || "Не указан"}
            </Descriptions.Item>
            <Descriptions.Item label="Контрагент" span={3}>
              {!orderData?.contragent_name
                ? "Не указан"
                : `${orderData?.contragent_name} (ном.: ${orderData?.contragent_phone})`}
            </Descriptions.Item>
            <Descriptions.Item label="Стоимость доставки" span={3}>
              {(orderData?.delivery_info?.delivery_price 
                ?? orderData?.delivery?.delivery_price 
                ?? orderData?.delivery_price) != null
                ? `${orderData?.delivery_info?.delivery_price 
                    ?? orderData?.delivery?.delivery_price 
                    ?? orderData?.delivery_price} руб.`
                : "Не указана"}
            </Descriptions.Item>
          </Descriptions>
  
          <Card title="Товары для сборки" style={{ marginTop: "20px" }}>
            {orderData?.goods && orderData.goods.length > 0 ? (
              <List itemLayout="horizontal">
                {orderData.goods.map((good, i) => {
                  return <GoodItem good={good} key={good?.id || i} />;
                })}
              </List>
            ) : (
              <Alert message="Нет товаров для сборки" type="warning" />
            )}
          </Card>
          {orderData && orderData.status === "collected" && orderData.assigned_picker && (
            <ImageList
              token={localStorage.getItem("authToken")}
              entity={"docs_sales"}
              entity_id={orderData?.id}
            />
          )}
  
          {userData && (
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <Alert
                message="Информация о пользователе"
                description={`Вы авторизованы как: ${userData.first_name || ""} ${
                  userData.last_name || ""
                } (ID: ${userData.id})`}
                type="info"
                showIcon
              />
            </div>
          )}
  
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {renderActionButtons()}
          </div>
        </Card>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <Spin size="large" />
        </div>
      )}

      <Modal
        title="Авторизация"
        open={isAuthModalVisible}
        onOk={handleAuthSubmit}
        onCancel={() => setIsAuthModalVisible(false)}
        okText="Сохранить"
        cancelText="Отмена"
      >
        <p>Введите ваш токен для доступа к API:</p>
        <Input.Password
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Введите токен"
        />
        {authError && (
          <div style={{ color: "red", marginTop: "5px" }}>{authError}</div>
        )}
        <div style={{ marginTop: "10px" }}>
          <a href="https://t.me/tablecrmbot" target="_blank" rel="noreferrer">
            У вас нет токена? Получите его в Telegram боте @tablecrmbot при
            прглашении в кассу
          </a>
        </div>
      </Modal>

      <div style={{ position: "fixed", top: "10px", right: "10px" }}>
        {userData ? (
          <Dropdown overlay={avatarMenu} trigger={["click"]}>
            <Avatar
              src={`https://${process.env.REACT_APP_APP_URL}/${userData?.photo}`}
              style={{ marginRight: 10, cursor: "pointer" }}
              size={50}
              icon={!userData?.photo && <UserOutlined />}
            />
          </Dropdown>
        ) : (
          <Button type="primary" onClick={() => setIsAuthModalVisible(true)}>
            Авторизоваться
          </Button>
        )}
      </div>
    </div>
  );
};

export default OrderPicker;

// function DescriptionBlock({ orderData, setOrderData }) {
//   const [loading, setLoading] = React.useState(false);
//   const [value, setValue] = React.useState(orderData?.description || null);

//   async function onChange() {
//     if (loading) return;

//     setLoading(true);
//     // axios

//     setTimeout(() => {
//       setLoading(false);
//       setValue(null);

//       message.success(`Описание было успешно добавлено`);

//       setOrderData?.((old) => {
//         return { ...old, description: value };
//       });
//     }, 2000);
//   }

//   return (
//     <Card title={"Описание"} style={{ marginTop: "20px" }}>
//       {(orderData?.description && value === null) ||
//       (!orderData?.description && value === null) ? (
//         <Flex gap={8} align={"flex-end"}>
//           <span style={{ whiteSpace: "pre-line" }}>
//             {orderData?.description || "Не указано"}
//           </span>
//           <Button
//             size={"small"}
//             onClick={() => {
//               setValue(orderData?.description || "");
//             }}
//           >
//             Изменить
//           </Button>
//         </Flex>
//       ) : (
//         <Flex vertical gap={12} align={"flex-end"}>
//           <TextArea
//             cols={4}
//             rows={6}
//             placeholder={"Описание..."}
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             disabled={loading}
//           />

//           <Flex gap={8} align={"center"}>
//             {orderData?.description ? (
//               <Button
//                 disabled={loading}
//                 onClick={() => {
//                   setValue(null);
//                 }}
//               >
//                 Отмена
//               </Button>
//             ) : null}
//             <Button
//               type={"primary"}
//               disabled={loading || value?.length < 8 || value?.length > 1024}
//               onClick={onChange}
//               loading={loading}
//             >
//               Сохранить
//             </Button>
//           </Flex>
//         </Flex>
//       )}
//     </Card>
//   );
// }

function GoodItem({ good }) {
  const [imageError, setImageError] = React.useState(false);

  return (
    <List.Item>
      <Flex gap={32} align={"flex-start"} style={{ width: "100%" }}>
        <Flex>
          <Image
            style={{
              borderRadius: "8px",
            }}
            width={100}
            height={"100%"}
            src={axiosBaseURL + "/" + good.picture_url || image404}
            fallback={image404}
            preview={!imageError}
            onError={() => setImageError(true)}
          />
        </Flex>
        <Flex vertical gap={4}>
          <Flex gap={8} align={"center"}>
            <span
              style={{
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              {good?.nomenclature_name || "Товар"}
            </span>
            <span
              style={{
                display: "block",
                background: "gray",
                borderRadius: "100%",
                width: "4px",
                height: "4px",
              }}
            ></span>
            <span
              style={{
                color: "gray",
                fontSize: "12px",
              }}
            >
              {good?.quantity || 0}
            </span>
            {/* {good?.nomenclature_unit_convent_national_view || 'единиц товара'} */}
          </Flex>
          <span
            style={{
              whiteSpace: "pre-line",
            }}
          >
            {good?.nomenclature_description_short ||
              good?.nomenclature_description_long ||
              "Описание товара не указано"}
          </span>
        </Flex>
      </Flex>
    </List.Item>
  );
}

GoodItem.propTypes = {
  good: PropTypes.object
};